import { get } from 'epics/ajax';
import { contextPath } from 'util/history';
import type { RequestSmartCardResponse } from './types';

export const canViewRequest = (requestKey: string, context: string = contextPath): Promise<boolean> => {
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard/canviewrequest`;

    return get(uri)
        .map((ajaxResponse) => {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return ajaxResponse.response.canViewRequest;
        })
        .toPromise()
        .catch((e) => Promise.reject(e));
};

export const getRequestSmartCardData = (
    requestKey: string,
    context: string = contextPath
): Promise<RequestSmartCardResponse> => {
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard`;

    return get(uri)
        .map((ajaxResponse) => {
            return ajaxResponse.response;
        })
        .toPromise()
        .catch((e) => Promise.reject(e));
};
